// @flow
// libs
import React, {useEffect, useState} from 'react';
import IMAGES from '../../constans/images';
import {Dropdown, DropdownButton} from "react-bootstrap";
import { ReactComponent as IconToTop } from '../../../assets/images/icon_top.svg'

type Props = {
  handleClick: Function,
  customClass?: string,
};

const BacktoTopComponent = ({
  handleClick,
  customClass = '',
}: Props) => {

  const [showScroll, setShowScroll] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowScroll(true)
      } else {
        setShowScroll(false)
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }

  }, []);

  const backToTop = () => {
    // scrollTo(0, 0)
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  const _handleClick = () => {

    if(typeof handleClick == 'function') {
      handleClick()
    }else {
      backToTop()
    }
  }

  return (
    showScroll ?
    <div className="back-to-top " onClick={_handleClick}>
      <label className="back-to-top__text">top</label>
      <div className='back-to-top__icon' style={{marginTop: -4}}>
        <IconToTop />
      </div>
    </div> : null
  );
};

BacktoTopComponent.defaultProps = {
  customClass: '',
};

export default BacktoTopComponent;
